import { render, staticRenderFns } from "./ButtonsServicioTecnico.vue?vue&type=template&id=2202ac88"
import script from "./ButtonsServicioTecnico.vue?vue&type=script&lang=js"
export * from "./ButtonsServicioTecnico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports